<template>
  <b-card id="press-release-detail">
    <h3>Pengumuman</h3>
    <p><span v-if="isEdit">Edit</span><span v-else>Tambah</span> pengumuman</p>
    <b-form-group
      v-for="form in fields"
      :key="form.label"
      :id="form.id"
      :label="capitalizeEachWord(form.label)"
      :label-for="`${form.label}-${form.id}`"
    >
      <mavon-editor
        v-if="form.label === 'description'"
        id="markdown-editor"
        language="en"
        :config="editorConfig"
        v-model="form.value"
      />

      <b-form-input
        v-if="['title', 'author'].includes(form.label)"
        :id="`${form.label}-${form.id}`"
        v-model="form.value"
        required
      ></b-form-input>

      <!-- <b-form-textarea
        v-else-if="
          form.label !== 'image' &&
          form.label !== 'event_start_at' &&
          form.label !== 'event_end_at' &&
          form.label !== 'icon'
        "
        :id="`${form.label}-${form.id}`"
        v-model="form.value"
        required
      ></b-form-textarea> -->

      <b-form-datepicker
        v-else-if="form.label == 'event_start_at' || form.label == 'event_end_at'"
        :min="new Date()"
        :id="`${form.label}-${form.id}`"
        v-model="form.value"
      ></b-form-datepicker>

      <div v-else-if="form.label == 'image' || form.label == 'icon'">
        <div v-if="form.src" class="mb-2">
          <img style="width: 200px; height: 200px; object-fit: contain" :src="form.src" alt="image" />
        </div>
        <b-form-file accept=".png,.jpg,.jpeg" @change="handleChangeFile($event, form)"></b-form-file>
      </div>
    </b-form-group>
    <div>
      <b-button class="btn-primary" @click="isEdit ? handleSaveEdit() : handleSaveAdd()">Save</b-button>
    </div>
  </b-card>
</template>

<script>
import axios from 'axios'
import config from '../../../config'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'AnnouncementDetail',
  components: { DatePicker },
  data() {
    return {
      data: null,
      fields: [],
      forms: ['no', 'title', 'description', 'image', 'author'],
      imagePath: null,
      editorConfig: {
        image: false, // Menonaktifkan fungsi unggah gambar
      },
    }
  },
  computed: {
    isEdit() {
      return !!this.$route.params.id
    },
  },
  async mounted() {
    if (this.isEdit) {
      await this.getData()
    }
    this.initForm()
  },
  methods: {
    initForm() {
      this.fields = this.forms.reduce((acc, f, idx) => {
        if (f == 'no' || f == 'aksi' || f == 'created_at' || f == 'updated_at') return [...acc]

        if (f == 'image') {
          return [
            ...acc,
            {
              id: `${f}-${idx}`,
              label: f,
              // value: this.isEdit ? config.webprofileApiUrl + '/company-profile/' + this.data['imageUrl'] : [],
              value: null,
              src: this.data ? config.webprofileApiUrl + '/company-profile/' + this.data['imageUrl'] : '',
            },
          ]
        }

        return [
          ...acc,
          {
            id: `${f}-${idx}`,
            label: f,
            value: this.isEdit ? this.data[f] : '',
          },
        ]
      }, [])
    },
    async getData() {
      const res = await axios.get(config.webprofileApiUrl + `/company-profile/gallery/${this.$route.params.id}`)

      if (res.data) {
        this.data = res.data
      }
    },
    async handleSaveEdit() {
      const id = this.data.id

      try {
        let bodyFormData = new FormData()

        bodyFormData.append('title', this.fields[0].value)
        bodyFormData.append('description', this.fields[1].value)
        bodyFormData.append('image', this.fields[2].value)
        bodyFormData.append('author', this.fields[3].value)
        // bodyFormData.append('event_start_at', new Date(this.fields[4].value).toISOString())
        // bodyFormData.append('event_end_at', new Date(this.fields[5].value).toISOString())

        await axios({
          method: 'patch',
          url: config.webprofileApiUrl + `/company-profile/gallery/${id}`,
          data: bodyFormData,
          headers: { 'Content-Type': 'multipart/form-data' },
        })

        this.$toasted.success('Berhasil Disimpan')
      } catch (err) {
        this.$toasted.error('Gagal Disimpan')
      } finally {
        this.getData()
      }
    },
    async handleSaveAdd() {
      try {
        let bodyFormData = new FormData()

        bodyFormData.append('title', this.fields[0].value)
        bodyFormData.append('description', this.fields[1].value)
        bodyFormData.append('image', this.fields[2].value)
        bodyFormData.append('author', this.fields[3].value)
        // bodyFormData.append('event_start_at', new Date(this.fields[4].value).toISOString())
        // bodyFormData.append('event_end_at', new Date(this.fields[5].value).toISOString())

        await axios({
          method: 'post',
          url: config.webprofileApiUrl + '/company-profile/gallery',
          data: bodyFormData,
          headers: { 'Content-Type': 'multipart/form-data' },
        })

        this.$toasted.success('Berhasil Ditambahkan')

        this.$router.push(`/app/web/press-release`)
      } catch (err) {
        this.$toasted.error('Gagal Ditambahkan')
      }
    },
    resetModal() {
      this.fields = null
      this.imagePath = null
    },
    handleClick() {
      this.$emit('click-ok', this.fields)
    },
    handleChangeFile(e, form) {
      const file = e.target.files[0]
      if (!file) return
      const newname = `${new Date().getTime()}${file.name}`
      const renamedFile = new File([file], newname, { type: file.type })
      const url = URL.createObjectURL(file)
      this.imagePath = url
      form.value = renamedFile
      form.src = url
      // const url = URL.createObjectURL(e.target.files[0])
      // this.imagePath = url
    },
    capitalizeEachWord(str) {
      return str
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')
    },
  },
}
</script>

<style>
#press-release-detail .markdown-body {
  z-index: 104;
}

#press-release-detail .b-calendar .b-calendar-grid {
  padding: 2rem;
}
</style>
